import * as giphyFetch from "@circle-react/helpers/giphyFetchHelpers";
import { flatten, uniqBy } from "lodash";
import { useMemo } from "react";
import { useInfiniteQuery } from "react-query";

import type { GiphyItem } from "./types";

interface GiphyPage {
  data: GiphyItem[];
  pagination: { offset: number; count: number; total_count: number };
}

const PAGE_SIZE = 10;

export const useGiphySearch = (query: string) => {
  const fetchGifs = ({ pageParam = 1 }): Promise<GiphyPage> =>
    query
      ? giphyFetch.search(query, { offset: pageParam, limit: PAGE_SIZE })
      : giphyFetch.trending({ offset: pageParam, limit: PAGE_SIZE });

  const { data, fetchNextPage, hasNextPage, isInitialLoading } =
    useInfiniteQuery({
      initialPageParam: 1,
      queryKey: ["giphy-picker-popover", query],
      queryFn: fetchGifs,
      getNextPageParam: lastPage => {
        const loadedItems =
          lastPage.pagination.offset + lastPage.pagination.count;
        const totalItems = lastPage.pagination.total_count;
        return loadedItems < totalItems
          ? lastPage.pagination.offset + PAGE_SIZE
          : null;
      },
    });

  const gifs = useMemo(
    () => uniqBy(flatten(data?.pages?.map(page => page.data) ?? []), "id"),
    [data],
  );

  return {
    gifs,
    fetchNextPage,
    hasNextPage: Boolean(hasNextPage),
    isInitialLoading,
  };
};
